import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { readableDateRange } from '@shared/utils/dates/readable-date-range';
import type { DateTime } from 'luxon';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'appTimestampRange' })
export class AppTimestampRange implements PipeTransform {
    transform(value: [string | DateTime, string | DateTime], includeTime = true): string {
        const from = toDateTime(value[0]);
        const to = toDateTime(value[1]);

        return readableDateRange(from, to, includeTime, true);
    }
}
